/* src/app/system-view/main-dashboard/main-dashboard.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.dash {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: var(--tem-space-2) var(--tem-space-3);
  font-family: var(--tem-font-family);
  color: var(--tem-ink);
}
.dash__float {
  position: fixed;
  top: 60px;
  z-index: 100;
}
.dash__float--back {
  right: 15px;
}
.dash__float--save {
  right: 70px;
}
.dash__main-data {
  margin-bottom: var(--tem-space-2);
  flex-shrink: 0;
}
.dash__main-data-desc {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
}
.dash__company-contract {
  display: flex;
  flex-direction: column;
  gap: var(--tem-space-2);
}
.dash__field {
  margin-bottom: 0;
}
.dash__tabs-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  position: relative;
}
.dash__tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.dash__tabs ::ng-deep .ant-tabs-content-holder,
.dash__tabs ::ng-deep .ant-tabs-content,
.dash__tabs ::ng-deep .ant-tabs-tabpane {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.dash__tab-title {
  font-size: var(--tem-fs-md);
}
.dash__tab-title-input {
  width: 140px;
}
.dash__tab-content {
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 0;
  padding-top: var(--tem-space-1);
}
.dash-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
  min-height: 52px;
  padding: var(--tem-space-1) var(--tem-space-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface-2);
  color: var(--tem-deep);
  flex-shrink: 0;
}
.dash-toolbar__title {
  margin: 0;
  padding: 0 var(--tem-space-2);
  font-size: var(--tem-fs-xl);
  font-weight: 600;
  color: var(--tem-ink);
}
.dash-toolbar__title-edit {
  max-width: 320px;
}
.dash-toolbar__clear {
  cursor: pointer;
  color: var(--tem-muted);
}
.dash-toolbar__clear:hover {
  color: var(--tem-danger);
}
.dash-toolbar__spacer {
  flex-grow: 1;
}
.dash-toolbar__link {
  font-size: var(--tem-fs-md);
  align-self: center;
  cursor: pointer;
  color: var(--tem-deep);
  text-decoration: none;
}
.dash-toolbar__link:hover {
  text-decoration: underline;
  color: var(--tem-accent);
}
.dash-toolbar__fab {
  align-self: center;
  box-shadow: var(--tem-shadow);
}
.dash-toolbar__fab:hover:not([disabled]) {
  border-color: var(--tem-accent);
  color: var(--tem-accent);
}
@keyframes fab-slide-in {
  from {
    opacity: 0;
    transform: translateX(8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.dash-toolbar__fab--edit {
  animation: fab-slide-in 0.2s;
}
.dash-toolbar__fab--filter {
  animation: fab-slide-in 0.3s;
}
.dash-toolbar__fab--add {
  animation: fab-slide-in 0.35s;
}
.dash-toolbar__fab--confirm {
  background: var(--tem-success);
  border-color: var(--tem-success);
  color: #fff;
}
.dash-toolbar__fab--confirm:hover:not([disabled]) {
  background: color-mix(in srgb, var(--tem-success) 85%, white);
  color: #fff;
}
.dash-menu__icon {
  margin-right: var(--tem-space-2);
}
.dash-menu__icon--deep {
  color: var(--tem-deep);
}
.dash-menu__icon--warn {
  color: var(--tem-warn);
}
.dash-menu__icon--success {
  color: var(--tem-success);
}
.dash__divider {
  margin: var(--tem-space-1) 0;
  flex-shrink: 0;
}
.dash__advanced {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding-top: var(--tem-space-2);
}
.dash__advanced-textarea {
  flex: 1;
  height: 100%;
  resize: none;
  font-family:
    "Consolas",
    "Menlo",
    monospace;
  font-size: var(--tem-fs-sm);
}
.dash__grid {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.dash__gridster {
  height: 100%;
  width: 100%;
  background: transparent;
}
.dash__gridster--edit {
  background: var(--tem-accent-soft);
  border-radius: var(--tem-radius);
}
.dash__gridster ::ng-deep gridster-item {
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface);
  overflow: hidden;
}
.dash__gridster ::ng-deep .gridster-preview {
  background: var(--tem-accent-soft);
  border-radius: var(--tem-radius);
}
.filter-layout {
  height: 100%;
  min-height: 0;
  flex: 1;
  background: transparent;
}
.filter-sider {
  height: 100%;
  border-right: 1px solid var(--tem-border);
  background: var(--tem-surface);
  margin-right: var(--tem-space-1);
}
.dashboard-content {
  height: 100%;
  min-height: 0;
  background: transparent;
}
.dashboard-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: 100%;
  position: relative;
  padding-left: var(--tem-space-1);
  background: transparent;
}
.filter-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.filter-panel__title-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
  padding: var(--tem-space-1);
  color: var(--tem-deep);
  font-weight: 500;
  flex-shrink: 0;
}
.filter-panel__icon {
  color: var(--tem-deep);
}
.filter-panel__title {
  font-weight: 500;
  font-size: var(--tem-fs-md);
}
.filter-panel__collapse-btn {
  flex: 1;
  text-align: end;
}
.filter-panel__divider {
  margin: 0;
  flex-shrink: 0;
}
.filter-panel__fields {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  padding-top: var(--tem-space-2);
  gap: var(--tem-space-2);
  background: var(--tem-surface);
}
.filter-panel__footer {
  margin-top: auto;
  padding: var(--tem-space-2) var(--tem-space-3) var(--tem-space-3);
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}
.filter-panel__apply {
  width: 100%;
}
.filter-panel--collapsed .filter-panel__title-bar {
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  padding: var(--tem-space-1) 0;
}
.filter-panel--collapsed .filter-panel__fields {
  display: none;
}
.filter-panel--collapsed .filter-panel__footer {
  padding: var(--tem-space-1) 0 var(--tem-space-2) 0;
}
@media (max-width: 920px) {
  .dash {
    padding: var(--tem-space-1);
  }
  .dash-toolbar__title {
    font-size: var(--tem-fs-lg);
  }
}
/*# sourceMappingURL=main-dashboard.component.css.map */
